import React from 'react'
import { CMSPath } from '../../../config/constant';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

const BookingConfirmation = (props) => {
  const { goNextPage, t } = props;
  return (
    <>
      <header className="inner-pages w-footer subpages">
                        
                        <div className="heading align-center">
                        <div class="header">
                            <p className="text">{t("way_activity.booking_confirmation_page.header_text")}</p>
                            {/* <img src={`${CMSPath}${props.logo}`} alt="" /> */}
                        </div>
                        </div>
      </header>
      <div className='booking-confirm'>
        <div className="container" dangerouslySetInnerHTML={{__html: props.t("way_activity.confirmation_page.main_message")}} >
         
        </div>
        {/* Actions */}
        <div className="booking-actions">
          {/* <button className="continue" onClick={goNextPage}>
            Close
          </button> */}

          {/* <button className="continue" onClick={()=>{}}>
            Back
          </button> */}
        </div>

        <div class="row">
                        <div class="form-controls">
                          <button  
                              className="continue"
                              onClick={goNextPage} >
                              {t("way_activity.booking_confirmation_page.close_button")}
                          </button>
                        </div>
       </div>

      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    installedAppVersion: state.store.installedAppVersion,
    installedAppBuildNo: state.store.installedAppBuildNo,
    currentHomePage: state.store2.currentHomePage,
    currentWidgetObj: state.store.sideNavBar.currentWidget,
    guestDetail: state.store.home.guestDetails,
    guestIsLoggedIn: state.store2.guestIsLoggedIn,
    currentWidgets: state.store.sideNavBar.currentWidget,
    dateFormat: state.store.home.clientConfig.extraConfigParam
      ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
      : "",
    // timeFormat: state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,
    serverTimeDate: state.store.home.serverTimeDate.date,
    serverDate: state.store.home.serverTimeDate,
  };
};

export default connect(mapStateToProps,
  {  })(
    withTranslation("translations")(BookingConfirmation)
  );
